import angular from 'angular';
import secureFileUploaderValidateErrorComponent from './secureFileUploaderValidateError.component';

let secureFileUploaderValidateErrorModule = angular.module('secureFileUploaderValidateError', []).component('secureFileUploaderValidateError', secureFileUploaderValidateErrorComponent);

export default secureFileUploaderValidateErrorModule;



// WEBPACK FOOTER //
// ./app/components/secureFileUploaderValidateError/secureFileUploaderValidateError.js